import {
  Toast,
  ToastClose,
  ToastDescription,
  type ToastProps,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@common/components/ui/toast"
import { useToast } from "@common/hooks/use-toast"
import { CircleAlert, CircleCheck } from "lucide-react"

export function Toaster({ className }: { className?: string }) {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <ToastIcon variant={props.variant} />
            <div className="grid min-w-0 flex-1 gap-0.5">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport className={className} />
    </ToastProvider>
  )
}

function ToastIcon({
  variant,
}: {
  variant: ToastProps["variant"]
}): React.ReactElement | null {
  switch (variant) {
    case "success":
      return <CircleCheck className="mt-0.5 size-4 shrink-0 text-semantic-success" />
    case "destructive":
      return <CircleAlert className="mt-0.5 size-4 shrink-0 text-semantic-error" />
    default:
      return null
  }
}
